import React from 'react'
import ReusableInput from '../../../components/comman/ReusableInput'
import { FaBuilding, FaEnvelope, FaUser } from 'react-icons/fa'
import ReusableSelect from '../../../components/comman/ReusableSelect'
import { PhoneNumberField } from '../../../components/comman/PhoneNumberField'
import Line from '../../../assets/svg/Line'
import { styles } from './Style'
import { RiLockPasswordLine } from 'react-icons/ri'

function FirstSetp({ formik = {} }) {

    const handlePhoneChange = ({countryCode,phoneNumber,}) => {
        // Update formik with the phone data structure
        formik.setFieldValue('phone', phoneNumber);
        formik.setFieldValue('phoneCode', countryCode);
    };

    return (
        <div className="form-step position-relative">
            {/* Top Left Red Dot */}
            <div className="position-absolute rounded-circle" style={styles.dont1}/>
            <div className="position-absolute rounded-circle" style={styles.dont2}/>

            {/* Curved Line SVG */}
            <div className="position-absolute" style={styles.lineWrapper}>
                <Line />
            </div>

            {/* Form Content */}
            <div className="row">
                <div className="col-md-12">
                    <ReusableInput
                        label="Contact Name"
                        value={formik.values.contactName}
                        onChange={formik.handleChange}
                        placeholder="Enter your name"
                        error={formik.touched.contactName && formik.errors.contactName}
                        name="contactName"
                        required
                        icon={<FaUser />}
                    />
                </div>
                <div className="col-md-12">
                    <ReusableInput
                        label="Email Address"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        placeholder="Enter your email"
                        error={formik.touched.email && formik.errors.email}
                        name="email"
                        required
                        icon={<FaEnvelope />}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        {/* <label className="input-label form-label" style={{color: "#1c1f1e"}}>
                            Phone Number <span className="text-danger">*</span>
                        </label> */}
                        <PhoneNumberField
                            value={{ countryCode: '', phoneNumber: formik.values.phone }}
                            onChange={handlePhoneChange}
                            error={formik.touched.phone && formik.errors.phone}
                        />
                    </div>
                </div>
                <div className="col-md-12">
                    <ReusableInput
                        label="Password"
                        value={formik?.values?.password}
                        onChange={formik.handleChange}
                        placeholder="Enter your password"
                        error={formik?.touched?.password && formik?.errors?.password}
                        name="password"
                        type="password"
                        required
                        // icon={<RiLockPasswordLine />}
                    />
                </div>
            </div>

        </div>
    )
}



export default FirstSetp